export const SIGN_UP_SMART_SEARCH_SELECTOR_NAME = 'signUpSmartSearch';
